import type { ReactNode } from "react";
import { PageHeader } from "./PageHeader";

export interface AdminPageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

/**
 * `AdminPageHeader` · unifica los headers de las 13 pantallas `/admin/*`
 * (hoy cada una arma su propio `<PageHeader breadcrumbs={[...]}>` a mano,
 * `INVENTARIO-UI.md` §4.2). Fija el breadcrumb `Inicio → Admin → {title}`
 * una sola vez — cada pantalla admin solo pasa `title`/`description`/`actions`.
 */
export function AdminPageHeader({ title, description, actions }: AdminPageHeaderProps) {
  return (
    <PageHeader
      title={title}
      description={description}
      actions={actions}
      breadcrumbs={[
        { label: "Inicio", href: "/dashboard" },
        { label: "Admin", href: "/admin" },
        { label: title },
      ]}
    />
  );
}
